export class VideoTimeFrameMetadata {
  constructor(
    public startsAtSecs: number,
    public endsAtSecs: number,
    public marginStartSecs: number,
    public marginEndSecs: number
  ) {}

  public get timeframeEndsSecs(): number {
    return this.endsAtSecs + this.marginEndSecs;
  }
}
